
import GenderIcon from './gender-icon'
import Datetime from '../../admin/components/datetime'
export default
    name: 'live-checkin'
    components: {GenderIcon, Datetime}
    props:
        href: String
        race_id: [Number, Array]
    data: ->
        heats: []
        fields: [
            {key: 'bib', label: i18n.t('bib')},
            {key: 'name', label: i18n.t('name'), isRowHeader: true},
            {key: 'time', label: i18n.t('passing_time')},
            #{key: 'status', label: i18n.t('status')},
        ]
        currentPage: 1
        perPage: 100
    computed:
        totalRows: -> @heats.length

    created: ->
        events =
            received: (data) ->
                if data.heat?
                    @heats.unshift(data.heat)
                if data.action?
                    @refresh() if 'update' == data.action

        if Array.isArray(@race_id)
            for id in @race_id
                @$cable._addChannel("LiveCheckinChannel_#{id}", events, @)
        else
            @$cable._addChannel("LiveCheckinChannel_#{@race_id}", events, @)

    beforeDestroy: ->
        if Array.isArray(@race_id)
            for id in @race_id
                @$cable._removeChannel("LiveCheckinChannel_#{id}")
        else
            @$cable._removeChannel("LiveCheckinChannel_#{@race_id}")

    mounted: ->
        @refresh() if 0 == @heats.length
        if Array.isArray(@race_id)
            for id in @race_id
                @$cable.subscribe({ channel: 'LiveCheckinChannel', race_id: id }, "LiveCheckinChannel_#{id}")
        else
            @$cable.subscribe({ channel: 'LiveCheckinChannel', race_id: @race_id }, "LiveCheckinChannel_#{@race_id}")

    methods:
        refresh: ->
            @axios.get(@href)
                .then (res) => @heats = res.data.heats
                .catch (e) -> console.log e

